import { useState } from 'react';

import CloseSvg from 'assets/filters/close.svg';
import Search from 'assets/filters/searchIcon.svg';
import Input from 'common-ui/input';
import { CloseIcon } from 'common-ui/modal/Modal.styles';

import { ClearAllColumn, ClearAllRow, ClearAllText, InputWrapper } from './ByUser.styles';

export const Filter = ({
  name,
  setName,
  surname,
  setSurname,
  email,
  setEmail,
  handleClearAll,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;
  return (
    <InputWrapper>
      <Input
        label="First name"
        leftIcon={Search}
        clearable
        value={name}
        onChange={(e) => setName(e.target.value)}
        onClear={() => setName('')}
        width={304}
      />
      <Input
        label="Last name"
        leftIcon={Search}
        value={surname}
        onChange={(e) => setSurname(e.target.value)}
        clearable
        onClear={() => setSurname('')}
        width={304}
      />
      <Input
        label="E-mail"
        leftIcon={Search}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        clearable
        onClear={() => setEmail('')}
        width={304}
      />
      <ClearAllRow onClick={handleClearAll}>
        <ClearAllColumn>
          <CloseIcon
            src={CloseSvg}
            alt="close"
            onClick={() => setIsOpen(false)}
            style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              cursor: 'pointer',
            }}
          />
          <ClearAllText>Clear all</ClearAllText>
        </ClearAllColumn>
      </ClearAllRow>
    </InputWrapper>
  );
};
